import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['Native iOS development (Swift, Objective-C)', 'Native Android development (Kotlin, Java)', 'Cross-platform architecture planning', 'App Store and Google Play submission', 'Push notifications and background services', 'Offline functionality and data sync'];
export function Capabilities() {
  return <section className="py-16" data-id="element-541">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-542">
        <div className="scroll-fade-in-up" data-id="element-543">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-544">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-545">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-546">
              Our mobile development team leverages the latest technologies and
              best practices to build applications that are not only visually
              stunning but also highly performant and secure. We focus on
              creating intuitive user interfaces and robust backend integrations
              to ensure a seamless experience for your users.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-547">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-548">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-549" />
                  <span className="text-gray-700" data-id="element-550">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}